// extracted by mini-css-extract-plugin
module.exports = {"mega-menu":"MegaMenu_mega-menu__S5Oqc","mega-menu__content":"MegaMenu_mega-menu__content__p7J_p"};